import { useI18n } from '../i18n';
import { Reveal } from './Reveal';
import { Bubbles } from './Bubbles';
import logo from '../assets/beercup-logo.webp';

type Props = {
  onPour: () => void;
};

export function Hero({ onPour }: Props) {
  const { t, locale } = useI18n();
  const playUrl = `https://play.google.com/store/apps/details?id=ch.beercup.app&hl=${locale}`;
  const appleUrl = 'https://apps.apple.com/ch/app/beercup-2026/id6770253194';
  return (
    <section class="hero">
      <Bubbles />
      <div class="container hero-inner">
        <div class="hero-top">
          <Reveal class="eyebrow" as="div">
            {t('hero.eyebrow')}
          </Reveal>
          <Reveal as="h1" class="display display-lead" delay={1}>
            {t('hero.title.line1a')} <em>{t('hero.title.line1b')}</em>
          </Reveal>
        </div>

        <div class="hero-bottom">
          <div class="hero-text">
            <Reveal class="display display-tail" delay={2}>
              {t('hero.title.line2')}
              <br />
              {t('hero.title.line3a')}
              <br />
              <em>{t('hero.title.line3b')}</em>
            </Reveal>
            <Reveal as="p" class="lede" delay={2}>
              {t('hero.lede')}
            </Reveal>

            <Reveal class="meta-row" delay={3}>
            <div class="meta-item">
              <div class="n">2026</div>
              <div class="l">{t('hero.meta.worldcup')}</div>
            </div>
            <div class="meta-item">
              <div class="n">
                <em>104</em>
              </div>
              <div class="l">{t('hero.meta.matches')}</div>
            </div>
            <div class="meta-item">
              <div class="n">
                CHF <em>0</em>
              </div>
              <div class="l">{t('hero.meta.toplay')}</div>
            </div>
          </Reveal>

          <Reveal class="stores" delay={4}>
            <a
              class="store-btn"
              href={appleUrl}
              target="_blank"
              rel="noreferrer"
            >
              <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.6 13.6c0-3 2.5-4.5 2.6-4.6-1.4-2.1-3.6-2.4-4.4-2.4-1.9-.2-3.6 1.1-4.6 1.1-1 0-2.4-1.1-4-1.1-2 0-3.9 1.2-4.9 3C.2 12.3 1.7 18 3.7 21c1 1.5 2.2 3.2 3.7 3.1 1.5-.1 2.1-1 3.9-1 1.8 0 2.3 1 3.9 1 1.6 0 2.7-1.5 3.7-3 1.2-1.7 1.6-3.4 1.7-3.5-.1 0-3.2-1.3-3.3-5z"
                  fill="#fff"
                />
                <path
                  d="M14.7 4.5c.8-1 1.4-2.4 1.3-3.8-1.2.1-2.7.8-3.5 1.8-.8.9-1.5 2.3-1.3 3.7 1.4.1 2.7-.7 3.5-1.7z"
                  fill="#fff"
                />
              </svg>
              <div>
                <span class="line1">{t('hero.stores.apple_line1')}</span>
                <span class="line2">{t('hero.stores.apple_line2')}</span>
              </div>
            </a>
            <a
              class="store-btn"
              href={playUrl}
              target="_blank"
              rel="noreferrer"
            >
              <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.5 1C1.2 1.3 1 1.8 1 2.5v21c0 .7.2 1.2.5 1.5l13-13L1.5 1z" fill="#00C3FF" />
                <path
                  d="M18.5 16.5l-3.9-3.9-13 13c.5.5 1.2.6 2 .1l14.9-8.6c.2 0 .3-.1.5-.2l-.5-.4z"
                  fill="#FFD500"
                />
                <path
                  d="M22.5 11L18.9 8.9l-4.4 4.1 4.4 4.1 3.6-2.1c1.1-.6 1.1-1.9 0-2.5l-.1.5z"
                  fill="#FF6B6B"
                />
                <path d="M18.9 8.9L3.5 0.2C2.7-.2 2 0 1.5.4l13 13L18.9 8.9z" fill="#00E676" />
              </svg>
              <div>
                <span class="line1">{t('hero.stores.google_line1')}</span>
                <span class="line2">{t('hero.stores.google_line2')}</span>
              </div>
            </a>
            <span class="stores-note" id="download">{t('hero.stores.note')}</span>
          </Reveal>

            <Reveal class="pour-row" delay={4}>
              <button class="pour-btn" type="button" onClick={onPour}>
                <span class="liquid" />
                <span class="foam" />
                <span class="inner-bubbles" />
                <span class="label">
                  {t('hero.pour.label')} <span class="arrow">→</span>
                </span>
              </button>
              <span class="pour-hint">
                {t('hero.pour.hint_a')}
                <br />
                {t('hero.pour.hint_b')}
              </span>
            </Reveal>
          </div>

          <Reveal class="logo-card" delay={2}>
            <img src={logo} alt="BeerCup 2026" />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
